import api from "./api";

export const deleteStaff = async (id) => {
  return api
    .delete({
      endpoint: `/staff/${id}`,
      port: process.env.REACT_APP_PORT_OWNER,
    })
    .then((res) => res.data)
    .catch((err) => err.response.data);
};
